import React from "react";

export default function Web_XML() {
  return (
    <div>
      <h1>What is XML</h1>
      <p>
        Route: <code>/web/xml</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
